// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.third-page {

    padding: 10mm;
    padding-bottom: 0;

}

.table_head{
  font-family: 'Lexend Deca', sans-serif;
  font-size: 11px;
}



`, "",{"version":3,"sources":["webpack://./src/views/admin/default/Report/ThirdPage/index.css"],"names":[],"mappings":"AAIA;;IAEI,aAAa;IACb,iBAAiB;;AAErB;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@400;500;600;700&display=swap');\n\n\n\n.third-page {\n\n    padding: 10mm;\n    padding-bottom: 0;\n\n}\n\n.table_head{\n  font-family: 'Lexend Deca', sans-serif;\n  font-size: 11px;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
